import { InternalAxiosRequestConfig } from 'axios';

export async function injectUserTimeZone(config: InternalAxiosRequestConfig) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  config.headers = config.headers ?? {};
  config.headers.Timezone = timezone;
  return config;
}
